export const INSTANT_GAME_TYPE = 'S';
export const DRAW_GAME_TYPE = 'O';



// WEBPACK FOOTER //
// ./src/modules/app/config/gametype.js